define(
	'controllers/loadControllers',[
		'controllers/conditionalLogic',
		'controllers/renderRecaptcha',
		'controllers/renderTurnstile',
		'controllers/renderHelpText',
		'controllers/fieldValuePreserver'
	],
	function
	(
		ConditionalLogic,
		RenderRecaptcha,
		RenderTurnstile,
		RenderHelpText,
		FieldValuePreserver
	)
	{
	var controller = Marionette.Object.extend( {
		initialize: function() {
			new ConditionalLogic();
			new RenderRecaptcha();
			new RenderTurnstile();
			new RenderHelpText();
			new FieldValuePreserver();
		}

	});

	return controller;
} );
